import { ReactNode } from "react";
import * as S from "./styles";

interface LinkProps {
  path: string;
  children?: ReactNode;
  target?: string;
}

export default function Link({ path, children, ...props }: LinkProps) {
  return (
    <S.Container href={path} {...props}>
      {children}
    </S.Container>
  );
}
